import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'CommunityPosts',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (this.loginDetails) {
            if (![1, 2, 3, 4, 5].includes(this.loginDetails.userType)) this.logout();
        } else {
            this.logout();
        }
        this.GetInfo(this.pageNo);
    },

    filters: {
        momentTime(date) {
            if (!date) return 'فارغ';
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            StatusFilter: 0,
            PostTypeFilter: 0,
            ScreenTitle: 'منشورات المجتمع',
            Info: [],
            Statistics: {}
        };
    },

    methods: {
        GetInfo(pageNo) {
            if (typeof pageNo === 'number' && pageNo > 0) {
                this.pageNo = pageNo;
            } else if (!pageNo) {
                this.pageNo = 1;
            }
            if (!this.Search) this.$blockUI.Start();
            this.$http.GetCommunityPosts(this.pageNo, this.pageSize, this.Search, this.StatusFilter, this.PostTypeFilter)
                .then(response => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.Statistics = response.data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.pages = 0;
                });
        },
        Approve(id) {
            Swal.fire({ title: 'تأكيد الموافقة', icon: 'question', showCancelButton: true, confirmButtonText: 'موافقة', cancelButtonText: 'إلغاء' })
                .then((result) => {
                    if (!result.isConfirmed) return;
                    this.$blockUI.Start();
                    this.$http.ApproveCommunityPost(id).then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.StatusFilter = 1;
                        this.pageNo = 1;
                        this.GetInfo(1);
                    }).catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
                    });
                });
        },
        Reject(id) {
            Swal.fire({ title: 'رفض المنشور', input: 'textarea', showCancelButton: true, confirmButtonText: 'رفض', cancelButtonText: 'إلغاء' })
                .then((result) => {
                    if (!result.isConfirmed) return;
                    this.$blockUI.Start();
                    this.$http.RejectCommunityPost(id, { Reason: result.value || '' }).then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.StatusFilter = 3;
                        this.pageNo = 1;
                        this.GetInfo(1);
                    }).catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
                    });
                });
        },
        Delete(id) {
            Swal.fire({ title: 'تأكيد الحذف', icon: 'warning', showCancelButton: true, confirmButtonText: 'حذف', cancelButtonText: 'إلغاء' })
                .then((result) => {
                    if (!result.isConfirmed) return;
                    this.$blockUI.Start();
                    this.$http.DeleteCommunityPost(id).then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.GetInfo(this.pageNo);
                    }).catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
                    });
                });
        }
    }
};
